<template>
    <el-select v-model="model"
               :value="value"
               :multiple="multiple"
               :collapse-tags="collapseTags"
               :filterable="filterable"
               :disabled="disabled"
               :clearable="clearable"
               :size="size"
               :class="clazz"
               @change="change($event)">
        <el-option v-for="location in locations" :key="location.locationid"
                   :value="location.locationid" :label="location.description">
        </el-option>
    </el-select>
</template>

<script>

    import LocationApi from "@/api/asset/location";

    export default {
        name: "location-select",
        props: {
            size: {},
            value: {},
            multiple: {},
            collapseTags: {},
            filterable: {},
            clearable: {},
            disabled: {},
            clazz: {},

            roomId: {},
            strategy: {
                type: String,
                default: 'default',
            },
        },
        data() {
            return {
                model: null,
                locations: [],
            };
        },
        watch: {
            value: {
                deep: true,
                immediate: true,
                handler(value) {
                    this.model = value;
                }
            },
            roomId: {
                immediate: true,
                handler() {
                    this.load();
                }
            }
        },
        methods: {
            async load() {
                let strategy = this.strategy, roomId = this.roomId;
                let locations;
                if (strategy === 'default') {
                    locations = await LocationApi.getLocationsByRoomId(roomId);
                } else if (strategy === 'roomIdNotNull') {
                    if (roomId == null || roomId === '') {
                        locations = [];
                    } else {
                        locations = await LocationApi.getLocationsByRoomId(roomId);
                    }
                }
                this.locations = locations;
                return Promise.resolve(locations);
            },
            change(event) {
                this.$emit('input', event);
                this.$emit('change', event);
            },
            getLabelByValue(value, locations) {
                let location;
                for (let i = 0, len = locations.length; i < len; i++) {
                    if (String(value) === String(locations[i].locationid)) {
                        location = locations[i];
                        break;
                    }
                }
                return location == null ? value : location.description;
            },
        },
        mounted() {
        },
        created() {
        },
    }
</script>

<style scoped>

</style>
